export default {
  downtimeUrl: "https://www.kodland.org/es",
  parameters: {
    landing_id: "LatFwdCSc",
    success_page: 'latam_thankyou_tiktok',
  },
  title: "Responde estas 8 preguntas y recibe una clase gratuita para tu hijo/a | Kodland",
  startPage: {
    image: "/welcome/fwd_latam_desk.png",
    imageMobile: "/welcome/fwd_latam_mob.png",
    title: "Responde estas 8 preguntas y recibe una clase gratuita para tu hijo/a",
    subtitle: "Tu hijo/a aprenderá creatividad digital: dibujos animados, animación, ilustración, modelado, 3D, diseño.",
    button: "Presiona para continuar🚀",
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
    button: "📆 Reservar una clase",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "¿Te gustaría que el tiempo que tu hijo/a pasa en la computadora fuera más productivo?",
      answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
    },
    2: {
      question: "¿Tu hijo o hija ha tomado clases en línea antes?",
      answers: [
        "👨‍💻 Sí, de forma regular",
        "⏳ Sí, solo una vez o por poco tiempo",
        "✨ No, todavía no"
      ],
    },
    3: {
      question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥 Nivel intermedio, quiere profundizar conocimientos",
        "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    4: {
      question: "¿Cómo crees que reaccionaría tu hijo o hija si le propusieras una clase de programación de prueba?",
      answers: [
        "🤩 Muestra interés en la programación",
        "🤔 No le interesa, pero podría aceptar probar",
        "🎨 Preferiría otras actividades (deporte, arte, etc.)",
        "🙅‍♂️ Diría que no quiere hacerlo"
      ],
    },
    5: {
      question:
        "En estos momentos, ¿Que es lo más importante para ti en el desarrollo de tu hijo/a?",
      answers: [
        "🤔 Habilidades blandas",
        "🎓 Preparación para una carrera a futuro",
        "🖥 Actividades extracurriculares",
      ],
    },
    6: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
    7: {
      question: "¿Qué presupuesto mensual te parece razonable para la educación de tu hijo o hija?",
      financial: true,
      answers: [
        "🌱 Hasta 30 USD",
        "🌿 30–60 USD",
        "🌳 60–100 USD",
        "🚀 Más de 100 USD"
      ],
    },
    8: {
      question: "¿Cuánto solías gastar al mes en actividades extracurriculares para tu hijo o hija?",
      answers: [
        "⚪ No gastábamos nada",
        "💸 20–50 USD",
        "💳 50–100 USD",
        "💎 Más de 100 USD"
      ],
    },
  },
};

